import { useMasterDataVehicleListPageProps } from "./fetch";
import { MasterDataVehicleListPageUi } from "./ui";

export const MasterDataVehicleListPage = () => {
  const props = useMasterDataVehicleListPageProps();
  return <MasterDataVehicleListPageUi {...props} />;
};
